export default "__VITE_ASSET__f9a25daf__"